export default "__VITE_ASSET__DQkdGk4B__"